import './shared';
import '../styles/home_index.css'


const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');

((
        ($) => {
            $(document).ready(function () {
                var Height = $(".background-img2").height() + 205;
                $(".background-img2").innerHeight(Height);

                $('.home-slider-carousel').owlCarousel({
                    loop: true,
                    margin: 0,
                    responsiveClass: true,
                    rtl:_isRtl,
                    animateIn:"fadeIn",
                    animateOut:"fadeOut",
                    autoplay:true,
                    items: 1,
                    dots: true,
                    nav: false,
                    autoplayTimeout: 5000,
                    autoplayHoverPause:true,
                    onInitialized: function (event) {
                        const element = event.target;
                        $(element).closest('.loading').removeClass('loading');
                    },
                });

                $('.list4-items-carousel').owlCarousel({
                    loop: true,
                    margin: 0,
                    responsiveClass: true,
                    rtl:_isRtl,
                    items: 1,
                    autoplay:true,
                    lazyLoad:true,
                    dots: true,
                    autoplayTimeout: 5000,
                    nav: false,
                    onInitialized: function (event) {
                        const element = event.target;
                        $(element).closest('.loading').removeClass('loading');
                    },
                });

            });

            $(window).scroll(function() {
               // debugger;
                if($(".list2-item-half").hasClass("aos-animate")){
                    const lines =  document.getElementsByClassName('ver-line');
                    for (let i = 0; i < lines.length; i++) {
                        if($("#line_"+i).hasClass("aos-animate") || $("#line2_"+i).hasClass("aos-animate")) {
                            setTimeout(function(){ $("#first-line").addClass("draw_line1"); }, 200);
                            setTimeout(function(){ $("#list2-image_"+i).addClass("show_img"); }, 400);
                            setTimeout(function(){ $("#ver_line_"+i).addClass("draw_line"); }, 400);
                        }
                    }
                } else{
                    $("#first-line").removeClass("draw_line1");
                    $(".list2-image").removeClass("show_img");
                    $(".ver-line").removeClass("draw_line");
                }
            });


            function HomeNews() {
                const wrapper = $('#owl-news');

                if ($(window).width() <= 575) {
                    wrapper.addClass('loading');
                    wrapper.find('.row').removeClass('row row10').addClass('owl-news owl-carousel owl-theme owl-dots-style');
                    wrapper.find('[class*="col-"]').removeClass('col-md-4 col-sm-4 d-flex').addClass('item');
                    wrapper.find('.owl-lazy').removeAttr('src');
                    wrapper.find("source").add("owl-lazy");
                    var Height = $(".background-img2").height() + 60;
                    //console.log('height',Height);
                    $(".background-img2").innerHeight(Height);
                }

                $('.owl-news').owlCarousel({
                    rtl: _isRtl,
                    margin: 0,
                    items: 1,
                    nav: false,
                    dots: true,
                    lazyLoad: true,
                    autoplay: false,
                    loop: false,
                    slideTransition: 'ease',
                    autoplayTimeout: 5000,
                    autoplaySpeed: 1000,
                    autoplayHoverPause: true,
                    onInitialized: function (event) {
                        const element = event.target;
                        $(element).closest('.loading').removeClass('loading');
                    },
                });
            }

            HomeNews();

            $(window).on('resize', function () {
                HomeNews();
            });

            if ($(window).width() < 800) {
                $('.list4-item').each(function (i, item) {
                    const _item = $(item);
                    const _desc = _item.find('.list4-desc');
                    if (!(_desc.html().trim() === '') && (_desc.html().length > 140)) {
                        _desc.html(_desc.html().substring(0, 140) + '...');
                    }
                });

                const wrapper = $('.list4-items');

                wrapper.find('.owl-lazy').removeAttr('src');
                wrapper.find('.owl-lazy').removeClass('lazyload');
            }

        }
    )
    (jQuery)
);
